import { useSyncExternalStore } from "react";

const TICK_MS = 60_000;

let now = new Date();
let intervalId: ReturnType<typeof setInterval> | undefined;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  if (intervalId === undefined) {
    now = new Date();
    intervalId = setInterval(() => {
      now = new Date();
      for (const notify of listeners) notify();
    }, TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) {
      clearInterval(intervalId);
      intervalId = undefined;
    }
  };
}

export default function useNow(): Date {
  return useSyncExternalStore(subscribe, () => now);
}
